// import React, { useState, useRef, useEffect } from "react";
// import "./dropdown.css";
// // import DropDownIcon from "../../Assets/Images/EployeeRegistration/icon-dropdown-menu.png";
// import DropDownIcon from "../../../Assets/Images/EployeeRegistration/icon-dropdown-menu.png";

// export default function DropDown({
//   width,
//   label,
//   selected,
//   setSelected,
//   options,
//   customWidth,
//   customTop,
//   isRequired,
//   Height,
//   OverFlow,
//   minheight,
//   placeholder = "",
//   marginLeft,
//   marginTop,
//   position,
//   disabled = false,
// }) {
//   const [isActive, setIsActive] = useState(false);
//   const [selectedLabel, setSelectedLabel] = useState("");
//   const dropdownRef = useRef(null);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsActive(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [dropdownRef]);

//   const handleClick = (option) => {
//     if (disabled) return; // Prevent interaction if disabled
//     setSelected(option.id);
//     setIsActive(false);
//     setSelectedLabel(option.label);
//   };

//   return (
//     <div
//       className="dropdown"
//       style={{ width, marginLeft, marginTop , 
//         opacity: disabled ? 0.6 : 1, // Add subtle faded effect when disabled
//         pointerEvents: disabled ? "none" : "auto", // Prevent interaction when disabled
//       }}
//       ref={dropdownRef}
//     >
//       <label>
//         {label}
//         {isRequired && <span>*</span>}
//       </label>
//       <div
//         className="dropdown-btn"
//         onClick={() => !disabled && setIsActive(!isActive)}
//         style={{
//           backgroundColor: disabled ? "#f5f5f5" : "white", // Faded background when disabled
//           cursor: disabled ? "not-allowed" : "pointer", // Change cursor when disabled
//         }}
//       >
//         {/* {selectedLabel} */}
//         {selectedLabel || placeholder}
//         <img src={DropDownIcon} alt="dropdown-icon" />
//       </div>
//       {isActive &&  !disabled && (
//         <div
//           className="dropdown-content"
//           style={{
//             width: customWidth,
//             top: customTop,
//             maxHeight: minheight,
//             height: Height,
//             overflow: OverFlow,
//             position: position,
//           }}
//         >
//           {options.map((option) => (
//             <div
//               key={option.id}
//               className="dropdown-item"
//               onClick={() => handleClick(option)}
//             >
//               {option.label}
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }












import React, { useState, useRef, useEffect } from "react";
import "./dropdown.css";
import DropDownIcon from "../../../Assets/Images/EployeeRegistration/icon-dropdown-menu.png";

export default function DropDown({
  width,
  label,
  selected,
  setSelected,
  options,
  customWidth,
  customTop,
  isRequired,
  Height,
  OverFlow,
  minheight,
  placeholder = "",
  marginLeft,
  marginTop,
  position,
  disabled = false,
}) {
  const [isActive, setIsActive] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState("");
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsActive(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClick = (option) => {
    if (disabled) return;
    setSelected(option.id);
    setIsActive(false);
    setSelectedLabel(option.label);
  };

  const handleClear = (e) => {
    e.stopPropagation();
    setSelected(null);
    setSelectedLabel("");
  };


  // remove the auto-selection logic from your dropdown 
  // useEffect(() => {
  //   if (selected && options?.length > 0) {
  //     const selectedOption = options.find((opt) => opt.id === selected);
  //     if (selectedOption) {
  //       setSelectedLabel(selectedOption.label);
  //     } else {
  //       setSelectedLabel("");
  //     }
  //   } else {
  //     setSelectedLabel("");
  //   }
  // }, [selected, options]);

  return (
    <div
      className="dropdown"
      style={{
        width,
        marginLeft,
        marginTop,
        opacity: disabled ? 0.6 : 1,
        pointerEvents: disabled ? "none" : "auto",
      }}
      ref={dropdownRef}
    >
      <label style={{color: "#6A6A6A"}}>
        {label}
        {isRequired && <span>*</span>}
      </label>
      <div
        className="dropdown-btn"
        onClick={() => !disabled && setIsActive(!isActive)}
        style={{
          backgroundColor: disabled ? "#f5f5f5" : "white",
          cursor: disabled ? "not-allowed" : "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingRight: "8px",
        }}
      >
        <span style={{ color: selectedLabel ? "#6A6A6A" : "#aaa" }}>
          {selectedLabel || placeholder}
        </span>
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          {selectedLabel && !isRequired && (
            <span
              style={{
                cursor: "pointer",
                color: "#aaa",
                fontSize: "16px",
                marginRight: "30px",
                userSelect: "none",
              }}
              onClick={handleClear}
            >
              ×
            </span>
          )}
          <img src={DropDownIcon} alt="dropdown-icon" />
        </div>
      </div>
      {isActive && !disabled && (
        <div
          className="dropdown-content"
          style={{
            width: customWidth,
            top: customTop,
            maxHeight: minheight,
            height: Height,
            overflow: OverFlow,
            position: position,
          }}
        >
          {options.map((option) => (
            <div
              key={option.id}
              className="dropdown-item"
              onClick={() => handleClick(option)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}



{
  /* <div className="selecte-dropdown-items">
                <label>Gender</label>
                <select
                  name="gender_id"
                  value={values.gender_id}
                  onChange={onChange}
                >
                  {genderdata &&
                    genderdata.map((gender) => (
                      <option key={gender.gender_id} value={gender.gender_id}>
                        {gender.gender_name}
                      </option>
                    ))}
                </select>
              </div> */
}
